import { Button } from "@mui/material"
import companyLogo from "@assets/images/S&P_Global_logo.svg"
import { useLocation } from "react-router"

export default function NotFound() {
  const location = useLocation()

  return (
    <div className="displayContainer">
      <img className="companyLogo" src={companyLogo} alt="S&P Global" />
      <h1>
        404 Not Found <b>:(</b>
      </h1>
      <h2>The link you are looking for cannot be found - {location.pathname}</h2>
      <Button href="/" variant="contained">
        Go back to home
      </Button>
    </div>
  )
}
